import user from "state/user";
import {SUBLEVELVIDEOS } from "constants/index";

type ArgType = {
  [key: string]: {};
};

export const sortString = ((input:string) => {
  return input.toLowerCase().split("").sort().join("");
})

export const calculateTotalPoints = (
  data: ArgType,
  isSubCategory?: boolean
) => {
  let totalPoints = 0;
  if (isSubCategory) {
    for (let [, value] of Object.entries(data)) {
      //@ts-ignore
      totalPoints += value.total_risk_value;
    }
    return totalPoints;
  } else {
    for (let [, value] of Object.entries(data)) {
      for (let [, _value] of Object.entries(value)) {
        //@ts-ignore
        totalPoints += _value.total_risk_value;
      }
    }
    return totalPoints;
  }
};

/**
 * The backend's score for a single SNP, or null when it could not be scored.
 *
 * Prefer this over re-deriving the score from `micronutrient.risk_value`. The
 * backend match handles strand-complement genotypes (Forward-strand Tempus
 * files) and the palindromic A/T and C/G cases; matching the raw rows here
 * missed both, and scored the unmatched SNPs as 0 instead of skipping them,
 * which dragged category averages down.
 *
 * DRF serializes DecimalField as a string ("50.00"), so this must be parsed.
 */
export const snpRiskPercentage = (record: any): number | null => {
  const percentage = record?.risk_percentage;
  if (percentage === null || percentage === undefined || percentage === "") {
    return null;
  }
  const parsed =
    typeof percentage === "number" ? percentage : parseFloat(percentage);
  return Number.isFinite(parsed) ? parsed : null;
};

/**
 * Average the backend scores, ignoring SNPs the backend could not score.
 * This mirrors how the report itself is built (services.py drops those rows).
 */
export const averageRiskPercentage = (records: any[]): number => {
  const scored = (records ?? [])
    .map(snpRiskPercentage)
    .filter((value): value is number => value !== null);

  if (scored.length === 0) return 0;
  return scored.reduce((sum, value) => sum + value, 0) / scored.length;
};

export const calculateTotalRiskSum = (data: any) => {
  return `${averageRiskPercentage(data)}`;
};

export const TotalRiskCalculator = (data:any ,key2:any) => {
  // get all subcategories of the given category
  const subcategories = data.subcategories.filter((item:any) => item.category === key2);
  const filteredRecords = data.records.filter((rec:any) => subcategories.some((sub:any) => sub.id === rec.subcategory));

  return `${averageRiskPercentage(filteredRecords)}`;
};

export const getSubCategoryLinks = (category:string, title:string)=>{
  // if(category === 'SLEEP') return `SLEEP/ONSET`
  // if(category === 'STRESS RESPONSE') return `STRESS%20RESPONSE/CORTISOL`
  // if(category === 'HORMONES') return `HORMONES/THYROID`
  return `${category}/${title}`
}


